// Third-party imports
import Glide from "@glidejs/glide"
import Aos from "aos";
// import { TweenMax, Power2 } from "gsap/TweenMax";
import SmoothScroll from "smooth-scroll";

// AW component imports
import Animate from "./animate";
import Counter from "./components/counter";


class Site {
    constructor() {
        this.body     = document.body;
        this.wrap     = document.querySelector('.js-wrap');
        this.isSlider = !!document.querySelector('.js-product-slider');

        // Slider init
        if (this.isSlider) {
            this.productSlider = new Glide('.js-product-slider', {
                type: 'carousel',
                startAt: 0,
                gap: 80,
            });
        }

        this.treesCounter = new Counter();
        this.animate      = new Animate();

        // smooth scroll init
        const scroll = new SmoothScroll('a[href*="#"]', {
            header: '[data-scroll-header]',
            speed: 200,
            updateURL: false
        });

        this.bind();
        // this.resize();
    }



    init() {
        // onScroll animations init
        Aos.init({ offset: 40 });

        this.setAsLoaded();

        this.treesCounter.init();
    }



    setAsLoaded() {
        this.body.classList.remove('loading');
        this.body.classList.add('is-loaded');

        // slider build
        // if (this.available.sliders) this.sliders.forEach(slider => slider.mount());
    }



    bind() {
        // window.addEventListener('resize', () => this.resize());
        window.addEventListener('beforeunload', () => {
            // this.body.scrollTop = document.documentElement.scrollTop = 0
        });

        if (this.applink) {
            this.applink.bind();
        }
    }


    resize() {
        // things to update onResize
    }

}

window.addEventListener('DOMContentLoaded', () => {
    const AWsite = new Site();
    AWsite.init();
    if(document.getElementById('playVideo')){
        playVideo();
    }
    const playBtn = document.getElementById('play-people-video');
    const playBtns = [... document.getElementsByClassName('video__wrapper')];
    const closeBtn = document.getElementById('close-people-video');
    const videoModal = document.getElementById('people-video');
    const videoPlayer = document.getElementById('play-people-video');

    const lazyVideos = document.querySelectorAll("video.lazy-video");

    const megaDropdown = document.querySelector('.mega__dropdown');
    const megaMenu = document.querySelector('.navbar__megamenu');
    const closeNavBtn = document.getElementById('close-megenav');

    // mega dropdown open and close functionality

    let timeoutId;

    megaDropdown.addEventListener('mouseover', () => {
        clearTimeout(timeoutId);
        megaMenu.style.display = 'flex';
    });

    megaDropdown.addEventListener('mouseleave', () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
         megaMenu.style.display = 'none';
        }, 500)
    });

    closeNavBtn.addEventListener('click', () => {
        clearTimeout(timeoutId);
        megaMenu.style.display = 'none';
    });

    // Dynamically adding (lazy loading) video.

    if ("IntersectionObserver" in window) {
      const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              let videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
            video.target.load();
            video.target.classList.remove("lazy-video");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    const disableScroll =  (event) => { 
        event.preventDefault();
        event.stopPropagation();
    }
    
    videoModal.addEventListener('scroll', disableScroll);

    if (playBtns.length > 0) {
        playBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                document.body.classList.add('disable-scroll');
                videoModal.classList.add('show');
                videoModal.querySelector('iframe').src = btn.getAttribute('data-url');
                videoPlayer.querySelector('video').pause();
                videoModal.addEventListener('scroll', disableScroll);
            });
        });
        // playBtn.addEventListener('click', () => {
        //     document.body.classList.add('disable-scroll');
        //     videoModal.classList.add('show');
        //     videoModal.querySelector('iframe').src = 'https://www.youtube.com/embed/N0HvOj_IeNc?autoplay=1&amp;controls=1&amp;showinfo=0&amp;modestbranding=1&amp;loop=1&amp;fs=0&amp;cc_load_policy=0&amp;iv_load_policy=3&amp;autohide=0&amp;enablejsapi=1&amp;rel=0';
        //     videoPlayer.querySelector('video').pause();
        // });
    }
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            document.body.classList.remove('disable-scroll');
            videoModal.classList.remove('show');
            videoModal.querySelector('iframe').src = '';
            videoPlayer.querySelector('video').play();
        });
    }
    if (videoModal) {
        videoModal.addEventListener('click', (event) => {
            if (event.target.nodeName === 'DIV') {
                document.body.classList.remove('disable-scroll');
                videoModal.classList.remove('show');
                videoModal.querySelector('iframe').src = '';
                videoPlayer.querySelector('video').play();
            }
        })
    }

if (window.location.pathname.includes('grow-your-brand')) {
    $(document).ready(function () {
      if (typeof $ === "undefined") {
        console.error("jQuery is not loaded");
        return;
      }
      if (typeof $.fn.slick === "undefined") {
        console.error("Slick carousel is not loaded");
        return;
      }

      const disableScroll = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
      const closeBtn = document.getElementById("close-grow-video");
      const videoModal = document.getElementById("grow-video");
      const videoPlayer = document.getElementById("grow-video-iframe");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          videoModal.classList.remove("show");
          videoModal.querySelector("iframe").src = "";
          if (videoPlayer && videoPlayer.querySelector("video")) {
            videoPlayer.querySelector("video").play();
          }
        });
      }
      if (videoModal) {
        videoModal.addEventListener("click", (event) => {
          if (event.target.nodeName === "DIV") {
            videoModal.classList.remove("show");
            videoModal.querySelector("iframe").src = "";
            if (videoPlayer && videoPlayer.querySelector("video")) {
              videoPlayer.querySelector("video").play();
            }
          }
        });
      }
      $(".slick-carousel").on("init", (s) => {
        const elem = s.target;
        console.log("Slick carousel initialized:", elem);
        elem.addEventListener("click", (e) => {
          const video = e.target.closest(".story-video");
          if (video) {
            const id = video.getAttribute("data-video-id");
            if (videoModal) {
              videoModal.classList.add("show");
              videoModal.querySelector(
                "iframe"
              ).src = `https://www.youtube.com/embed/${id}?autoplay=1&amp;controls=1&amp;showinfo=0&amp;modestbranding=1&amp;loop=1&amp;fs=0&amp;cc_load_policy=0&amp;iv_load_policy=3&amp;autohide=0&amp;enablejsapi=1&amp;rel=0`;
            }
          }
        });
      });

      const commonConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 10,
        autoplay: true,
        centerMode: true,
        autoplaySpeed: 2000,
        variableWidth: true,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 720,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };

      const handleSliderInteraction = ($slider) => {
        let userInteracted = false;

        $slider.on("mousedown touchstart", function () {
          userInteracted = true;
        });

        $slider.on("mouseup touchend", function () {
          if (userInteracted) {
            userInteracted = false;
            $slider.slick("slickPlay");
          }
        });

        $slider.on("click", ".slick-dots button", function (e) {
          userInteracted = false;
          setTimeout(function () {
            $slider.slick("slickPlay");
          }, 50);
        });
      };

      $(".slick-carousel").each(function () {
        const $slider = $(this);
        let config = { ...commonConfig };

        if (
          $slider.hasClass("grow-testimonial") ||
          $slider.hasClass("grow-testimonial__guide")
        ) {
          config = {
            ...commonConfig,
            autoplaySpeed: 3000,
          };
        } else if ($slider.hasClass("grow-testimonial__masterclass")) {
          config = {
            ...commonConfig,
            dots: false,
          };
        }

        $slider.slick(config);
        handleSliderInteraction($slider);
      });
    });

    //   document.querySelectorAll('.slick-carousel').map((item) => {
    //     item.addEventListener('click', (event) => {
    //         console.log(event);
    //     });
    //   })
}

    if (window.location.pathname.includes('graduates')) {
        stepperInit();
        const isMobile = getDeviceType() === "mobile";
        if (isMobile) {
            stepperAnimate();
        }
        const swiper = new Swiper('.swiper', {
            slidesPerView: 2,
            centeredSlides: true,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false
            },
            spaceBetween: 40
        });
      }
});



// WEBPACK FOOTER //
// ./src/js/index.js